import * as api from 'api/recipe/PostRecipeSearchV1';

export default class TagCategory {
	public id: string = '';
	public name: string = '';

	public constructor(input?: api.TagCategory | null) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapFromApi(input: api.TagCategory | null): void {
		if (input) {
			this.id = input.id;
			this.name = input.name ?? '';
		}
	}
}
